export default "__VITE_ASSET__CAcYhvgs__"